(() => {
  'use strict';
  const states = new WeakMap();
  function init(scope = document) {
    scope.querySelectorAll('.bcw-usa-product-ux').forEach(section => {
      if (states.has(section)) return;
      const info = section.querySelector('product-info');
      const summary = section.querySelector('.bcw-usa-price-summary');
      if (!info || !summary) return;
      let frame = null;
      function refresh() {
        frame = null;
        const card = info.querySelector('[data-variant-id].selected');
        const price = card?.querySelector('[data-variant-current], [data-bcw-single-price]');
        const compare = card?.querySelector('[data-variant-compare], [data-bcw-single-compare]');
        if (price) {
          const target = summary.querySelector('[data-bcw-unit-price]');
          const compareTarget = summary.querySelector('[data-bcw-unit-compare]');
          if (target.textContent !== price.textContent.trim()) target.textContent = price.textContent.trim();
          const compareText = compare?.textContent.trim() || '';
          if (compareTarget.textContent !== compareText) compareTarget.textContent = compareText;
          compareTarget.hidden = !compareText || compareText === target.textContent;
        }
      }
      function schedule() { if (frame === null) frame = requestAnimationFrame(refresh); }
      const observer = new MutationObserver(schedule);
      observer.observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      info.addEventListener('change', schedule);
      document.addEventListener('discount:applied', schedule);
      section.addEventListener('keydown', event => {
        const card = event.target.closest('[data-variant-id]');
        if (event.target.matches('input[type="radio"]') && card && event.key === ' ') {
          event.preventDefault();
          if (!event.target.disabled) card.click();
        }
      });
      const reviews = document.querySelector('section[id^="testimonials-"], #judgeme_product_reviews, .jdgm-review-widget');
      const reviewLink = section.querySelector('.bcw-usa-reviews-link');
      if (reviews && reviewLink) {
        if (!reviews.id) reviews.id = 'bcw-usa-customer-reviews';
        reviewLink.href = '#' + reviews.id;
        reviewLink.hidden = false;
      }
      states.set(section, { observer, schedule, getFrame: () => frame, info });
      refresh();
    });
  }
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.bcw-usa-product-ux').forEach(section => {
      const state = states.get(section);
      if (!state) return;
      state.observer.disconnect();
      state.info.removeEventListener('change', state.schedule);
      document.removeEventListener('discount:applied', state.schedule);
      if (state.getFrame() !== null) cancelAnimationFrame(state.getFrame());
      states.delete(section);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', () => init());
})();
